import type {ReactElement} from 'react';
import React from 'react';
import type {LineColorOptionProps} from '@Components/poster-editor/components/poster-editing-side-panel/components/LineColorOption/LineColorOption.types';
import {type ColorFillStorage, ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {convertFabricColorToColorPickerColor, getColorPickerColorTypeFromFabricColor} from '@Utils/color.util';
import {useGetKeyFromActiveItem} from '@Hooks/poster-editor/useGetKeyFromActiveItem';

export function LineColorOption(props: LineColorOptionProps): ReactElement {
  const fill = useGetKeyFromActiveItem('fill');

  if (fill === undefined) {
    throw new Error(`Item doesn't have fill property`);
  }
  const getColorObject = (): ColorFillStorage[] => {
    return [
      {
        id: 'color-fill-vector',
        fillType: getColorPickerColorTypeFromFabricColor(fill),
        color: convertFabricColorToColorPickerColor(fill),
      },
    ];
  };

  const onClickColorFill = (): void => {
    props.onClickColorFill();
  };

  return <ContextualMenuColorFillOption id="line-color-option" label={window.i18next.t('pmwjs_color')} data={getColorObject()} onClick={onClickColorFill} />;
}
